import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import AboutSection from "@/components/AboutSection";
import ProductsSection from "@/components/ProductsSection";
import ShippingSection from "@/components/ShippingSection";
import PracticesSection from "@/components/PracticesSection";
import InfrastructureSection from "@/components/InfrastructureSection";
import AwardsSection from "@/components/AwardsSection";
import TeamSection from "@/components/TeamSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#F9F8F4]" data-testid="home-page">
      <Navigation scrolled={scrolled} />
      <HeroSection />
      <AboutSection />
      <ProductsSection />
      <ShippingSection />
      <PracticesSection />
      <InfrastructureSection />
      <AwardsSection />
      <TeamSection />
      <ContactSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}
